import React from 'react';

export default function VerificationOverlay({ isVisible, message, isComplete }) {
  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
        backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center',
        justifyContent: 'center', zIndex: 2000, flexDirection: 'column', gap: 24,
      }}
    >
      {!isComplete ? (
        <div
          style={{
            width: 64, height: 64, borderRadius: '50%',
            border: '4px solid rgba(37,99,235,0.2)',
            borderTopColor: '#2563EB',
            animation: 'spin 0.8s linear infinite',
          }}
        />
      ) : (
        <div
          style={{
            width: 64, height: 64, borderRadius: '50%',
            background: '#16A34A', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            animation: 'scaleIn 0.3s ease',
          }}
        >
          <svg
            width="32" height="32" viewBox="0 0 24 24" fill="none"
            stroke="white" strokeWidth="3" strokeLinecap="round"
            strokeLinejoin="round"
            style={{ animation: 'drawCheck 0.5s ease 0.1s both' }}
          >
            <polyline points="4 12 10 18 20 6" />
          </svg>
        </div>
      )}
      <div style={{
        color: 'white', fontSize: 18, fontWeight: 600,
        textAlign: 'center', maxWidth: 400,
      }}>
        {message}
      </div>
      <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>
        Please do not close this page
      </div>
    </div>
  );
}
